import routes from '@routes/config';

export default [{
    path: routes.noteRow.index,
    name: routes.noteRow.index,
    component: () => import(/* webpackChunkName: "NoteRow" */  '@components/NoteRow/Index')
}]
